import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Catalogo = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-12 md:pt-40 md:pb-20 bg-gradient-to-br from-[#0a2a5e] via-[#0f3d8c] to-[#0a3570]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">Catálogo de Productos</h1>
            <p className="text-base md:text-lg lg:text-xl opacity-95 mb-6 md:mb-8">
              Encuentra todo lo que tu empresa necesita en un solo lugar
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
              <a
                href="https://wa.me/+522228121142"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg md:text-xl"></i>
                Solicitar Cotización
              </a>
              <a
                href="tel:+522228121142"
                className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold hover:bg-white/20 transition-all border border-white/20 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-lg md:text-xl"></i>
                Llamar Ahora
              </a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Categorías */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">Nuestras Categorías</h2>
            <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
              Selecciona la categoría que necesitas y solicita tu cotización directamente por WhatsApp
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {/* Categoría 1 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Suministro de Oficina"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://public.readdy.ai/ai/img_res/b74a06ae483a367306be85005e8d6ea7.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-briefcase-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Suministro de Oficina</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Papelería, folders, archivadores, bolígrafos, notas adhesivas, cintas y todo lo que tu oficina necesita para operar con eficiencia.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Suministro%20de%20Oficina"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
            
            {/* Categoría 2 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Artículos de Limpieza"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://public.readdy.ai/ai/img_res/da4b4227c30e80f0da1c9620be08b5dd.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-sparkling-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Artículos de Limpieza</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Detergentes, desinfectantes, escobas, trapeadores, bolsas de basura y productos de higiene para mantener tus espacios impecables.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Art%C3%ADculos%20de%20Limpieza"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
            
            {/* Categoría 3 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Insumos Médicos"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=medical%20supplies%20gloves%20masks%20syringes%20gauze%20bandages%20first%20aid%20kit%20organized%20on%20clean%20white%20background%20professional%20healthcare%20products%20photography%20high%20quality&width=600&height=400&seq=cx-cat-medico&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-heart-pulse-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Insumos Médicos</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Guantes de látex, cubrebocas, jeringas, gasas, vendas y materiales de curación para clínicas, consultorios y empresas.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Insumos%20M%C3%A9dicos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
            
            {/* Categoría 4 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Desechables y Consumibles"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=disposable%20products%20cups%20plates%20cutlery%20napkins%20straws%20packaging%20organized%20on%20clean%20white%20background%20product%20photography%20high%20quality%20minimal&width=600&height=400&seq=cx-cat-desechables&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-cup-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Desechables y Consumibles</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Vasos, platos, cubiertos, servilletas, popotes y empaques desechables para uso diario en oficinas, restaurantes y eventos.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Desechables%20y%20Consumibles"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
            
            {/* Categoría 5 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Consumibles para Impresora"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=printer%20ink%20cartridges%20toner%20compatible%20brands%20organized%20on%20clean%20white%20background%20product%20photography%20high%20quality%20office%20printing%20supplies&width=600&height=400&seq=cx-cat-impresora&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-printer-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Consumibles para Impresora</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Tintas, tóners, cartuchos y cintas de impresión compatibles con las principales marcas del mercado para mantener tu equipo funcionando.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Consumibles%20para%20Impresora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
            
            {/* Categoría 6 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Mercería"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=sewing%20notions%20haberdashery%20threads%20needles%20buttons%20zippers%20elastic%20ribbons%20organized%20on%20clean%20white%20background%20product%20photography%20high%20quality%20craft%20supplies&width=600&height=400&seq=cx-cat-merceria&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-scissors-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Mercería</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Hilos, agujas, botones, cierres, elásticos, telas y accesorios de costura para talleres, sastrerías y uso doméstico.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Mercer%C3%ADa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
            
            {/* Categoría 7 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Artículos de Cuidado Personal"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=personal%20care%20products%20collection%20shampoo%20bottles%20lotion%20pump%20dispensers%20bar%20soap%20bath%20sponge%20loofah%20arranged%20together%20on%20clean%20pure%20white%20background%20soft%20natural%20lighting%20product%20photography%20flat%20lay%20close%20up%20beauty%20hygiene%20items&width=600&height=400&seq=cx-cat-personal-v2&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-user-heart-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Artículos de Cuidado Personal</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Shampoo, jabón, cremas, desodorantes, papel higiénico y productos de higiene personal para empresas, hoteles y uso institucional.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Art%C3%ADculos%20de%20Cuidado%20Personal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
            
            {/* Categoría 8 */}
            <div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(15,61,140,0.45)]">
              <div className="relative w-full h-48 overflow-hidden bg-gray-50">
                <img
                  alt="Artículos para Fiestas y Decoración de Eventos"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=party%20decoration%20supplies%20balloons%20tablecloths%20centerpieces%20streamers%20colorful%20festive%20items%20organized%20on%20clean%20white%20background%20product%20photography%20high%20quality%20event%20decor&width=600&height=400&seq=cx-cat-fiestas&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#0f3d8c] rounded-full shadow-md">
                  <i className="ri-gift-line text-white text-base"></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">Artículos para Fiestas y Decoración de Eventos</h3>
                <p className="text-sm text-gray-500 mb-5 leading-relaxed line-clamp-3">
                  Globos, manteles, centros de mesa, serpentinas, piñatas y decoraciones para todo tipo de celebraciones y eventos corporativos.
                </p>
                <a
                  href="https://wa.me/+522228121142?text=Hola%2C%20me%20interesa%20cotizar%20productos%20de%20la%20categor%C3%ADa%3A%20Art%C3%ADculos%20para%20Fiestas%20y%20Decoraci%C3%B3n%20de%20Eventos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-[#0a2a5e] to-[#0f3d8c]">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 md:mb-6">¿No Encuentras lo que Buscas?</h2>
            <p className="text-base md:text-lg mb-6 md:mb-8 opacity-95">
              Contamos con acceso a más de 150 marcas. Contáctanos y te ayudamos a encontrar exactamente lo que necesitas.
            </p>
            <a
              href="https://wa.me/+522228121142?text=Hola%2C%20necesito%20informaci%C3%B3n%20sobre%20sus%20productos"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg md:text-xl"></i>
              Contactar por WhatsApp
            </a>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Catalogo;